import { List } from "antd";
import styled from "styled-components";

export const ListItem = styled(List.Item)`
    cursor: pointer;
    
    &:hover { 
        background: #f5f5f5; 
    }
`;